export const SUPPORT_CENTER_URL = 'https://shadewave.com/support-center/';
